/**
 * 主要是增删改的接口使用，避免多次点击
 * 如果业务逻辑复杂或需要await 多个接口，推荐页面局部使用 const toastInstance = Toast.loading... toastInstance.clear();toastInstance=null;
 */

import { Toast } from "vant";

let loadingCount = 0;
let toastInstance = null;

const loadingManager = {
  show(url) {
    loadingCount++;
    if (!toastInstance) {
      // console.log(loadingCount, "loadingCount", url);
      toastInstance = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
    }
  },
  hide(url) {
    if (loadingCount > 0) loadingCount--;
    // console.log(loadingCount, "loadingCount", url);
    if (loadingCount === 0 && toastInstance) {
      toastInstance.clear();
      toastInstance = null;
    }
  },
  reset() {
    loadingCount = 0;
    toastInstance.clear();
    toastInstance = null;
  }
};

export default loadingManager;
